<template>
  <div>
    <!-- Header -->

    <!-- Page content -->
    <b-container class="py-7 py-lg-8 pt-lg-9">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <b-list-group>
                <b-list-group-item href="/#/auth/ListCarDetail"
                  >ข้อมูลรถ</b-list-group-item
                >
                <b-list-group-item href="javascript:;"
                  >ภาษีรถยนตร์</b-list-group-item
                >
                <b-list-group-item href="/#/auth/ListCarMantainace"
                  >ประวัติการซ่อม</b-list-group-item
                >
                <b-list-group-item href="javascript:;"
                  >ประกันภัยรถยนตร์</b-list-group-item
                >
                <b-list-group-item href="javascript:;"
                  >ประวัติการซ่อม</b-list-group-item
                >
                <b-list-group-item href="javascript:;"
                  >ประวัติการอุบัติเหตุ</b-list-group-item
                >
                <b-list-group-item href="javascript:;"
                  >สัญญาเช่ารถ</b-list-group-item
                >
              </b-list-group>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
    },
  },
};
</script>
